import { CSSProperties } from "react";

export const Wave = ({
  color = "#CAC0FC",
  thickness = 3,
  width = 584,
  height = 38,
  className,
  style,
}: {
  color?: string;
  svgWidth?: number;
  thickness?: number;
  width?: number;
  height?: number;
  className?: string;
  style?: CSSProperties;
}) => {
  return (
    <svg
      className={className}
      style={style}
      width={`${width}`}
      height={height}
      viewBox={`0 0 ${width} ${height / 2 - thickness}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5_340)">
        <path
          d="M584 23.7033C554.798 23.7033 554.798 1.29668 525.604 1.29668C496.411 1.29668 496.402 23.7033 467.2 23.7033C437.998 23.7033 437.998 1.29667 408.804 1.29667C379.611 1.29667 379.602 23.7033 350.4 23.7033C321.198 23.7033 321.198 1.29666 292.004 1.29666C262.811 1.29666 262.802 23.7033 233.609 23.7033C204.415 23.7033 204.406 1.29665 175.204 1.29665C146.002 1.29665 146.002 23.7033 116.809 23.7033C87.6151 23.7033 87.6065 1.29664 58.4043 1.29664C29.2022 1.29664 29.2022 23.7033 -4.49297e-06 23.7033"
          stroke={color}
          strokeWidth={thickness}
          strokeMiterlimit={10}
        />
      </g>
    </svg>
  );
};
